import React from "react";
import dynamic from "next/dynamic";
import { ErrorBoundary } from "@catchoftheday/cg-components";
import { nextAppHOC } from "@catchoftheday/common-vendors";
import { getEnvConfig, withEnvConfig } from "@catchoftheday/env-config";
import { jsx as ___EmotionJSX } from "@emotion/react";
var DynamicLoadMock = dynamic(function () {
  return import("../mocks/index");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../mocks/index")];
    }
  }
});

function PrivacyApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  return ___EmotionJSX(ErrorBoundary, null, false && // eslint-disable-next-line n/no-process-env
  process.env.NEXT_PUBLIC_USE_MOCK === "true" && ___EmotionJSX(DynamicLoadMock, null), ___EmotionJSX(Component, pageProps));
}

export default withEnvConfig(nextAppHOC({
  graphqlEndpoint: function graphqlEndpoint() {
    return getEnvConfig().GRAPHQL_ENDPOINT;
  }
})(PrivacyApp));